import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import AgencyMenu from '../../../../Components/AgencyMenu'
import Headline from '../../../../Components/Headline'
import firebase from 'firebase/app'
import {
  Card,
  CardContent,
  CardHeader,
  FormControlLabel,
  List,
  ListItem,
  Switch
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { systemColors } from '../../../../globalVariables'

const db = firebase.firestore()

const useStyles = makeStyles({
  labelSize: {
    fontSize: 14
  },
  cardSubheader: {
    fontSize: 15,
    color: systemColors.darkBlue
  }
})

const DashboardSettings = ({ userData }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { userRole, settings, uid } = userData

  const [lastViewedCompanies, setLastViewedCompanies] = useState(
    settings.userSettings.dashboard.allowLastViewedCompaniesKEY
  )
  const [lastViewedProfiles, setLastViewedProfiles] = useState(
    settings.userSettings.dashboard.allowLastViewedProfilesKEY
  )
  const [taggedProfiles, setTaggedProfiles] = useState(
    settings.userSettings.dashboard.allowTaggedProfilesKEY
  )
  const [lastAgencyApplicants, setLastAgencyApplicants] = useState(
    settings.userSettings.dashboard.allowLastAgencyApplicantsKEY
  )
  const [lastOnlineApplicants, setLastOnlineApplicants] = useState(
    settings.userSettings.dashboard.allowLastOnlineApplicantsKEY
  )

  const changeLastViewedCompaniesStatus = async () => {
    if (!lastViewedCompanies) {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastViewedCompaniesKEY': true
        })
        .then(() => setLastViewedCompanies(true))
        .catch((error) => console.log("Can't update dashboard setting", error))
    } else {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastViewedCompaniesKEY': false
        })
        .then(() => setLastViewedCompanies(false))
        .catch((error) => console.log("Can't update dashboard setting", error))
    }
  }

  const changeLastViewedProfileStatus = async () => {
    if (!lastViewedProfiles) {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastViewedProfilesKEY': true
        })
        .then(() => setLastViewedProfiles(true))
        .catch((error) => console.log("Can't update dashboard setting", error))
    } else {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastViewedProfilesKEY': false
        })
        .then(() => setLastViewedProfiles(false))
        .catch((error) => console.log("Can't update dashboard setting", error))
    }
  }

  const changeTaggedProfilesStatus = async () => {
    if (!taggedProfiles) {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowTaggedProfilesKEY': true
        })
        .then(() => setTaggedProfiles(true))
        .catch((error) => console.log("Can't update dashboard setting", error))
    } else {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowTaggedProfilesKEY': false
        })
        .then(() => setTaggedProfiles(false))
        .catch((error) => console.log("Can't update dashboard setting", error))
    }
  }

  const changeLastAgencyApplicantsStatus = async () => {
    if (!lastAgencyApplicants) {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastAgencyApplicantsKEY': true
        })
        .then(() => setLastAgencyApplicants(true))
        .catch((error) => console.log("Can't update dashboard setting", error))
    } else {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastAgencyApplicantsKEY': false
        })
        .then(() => setLastAgencyApplicants(false))
        .catch((error) => console.log("Can't update dashboard setting", error))
    }
  }

  const changeLastOnlineApplicantsStatus = async () => {
    if (!lastOnlineApplicants) {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastOnlineApplicantsKEY': true
        })
        .then(() => setLastOnlineApplicants(true))
        .catch((error) => console.log("Can't update dashboard setting", error))
    } else {
      await db
        .collection('users')
        .doc(uid)
        .update({
          'data.settings.userSettings.dashboard.allowLastOnlineApplicantsKEY': false
        })
        .then(() => setLastOnlineApplicants(false))
        .catch((error) => console.log("Can't update dashboard setting", error))
    }
  }

  return (
    <div>
      <Headline text={t('dashboardSettings')} />
      <AgencyMenu type='key' />

      <div style={{ marginTop: 50 }}>
        <Card style={{ width: 'fit-content', margin: 'auto' }}>
          <CardHeader
            classes={{ subheader: classes.cardSubheader }}
            subheader={t('selectWhichDasboardBlocksToShow')}
          />
          <CardContent>
            <List>
              {/* Last visited companies */}
              {userRole === 'agency_admin' ||
              userRole === 'super_admin' ||
              settings.adminPermissions.dashboard
                .allowLastViewedCompaniesKEY === true ? (
                <ListItem>
                  <FormControlLabel
                    label={t('lastViewedCompanies')}
                    labelPlacement='start'
                    classes={{ label: classes.labelSize }}
                    control={
                      <Switch
                        checked={lastViewedCompanies}
                        onChange={() => changeLastViewedCompaniesStatus()}
                        size='small'
                        color='orange'
                      />
                    }
                  />
                </ListItem>
              ) : null}

              {/* Last visited employees */}
              {userRole === 'agency_admin' ||
              userRole === 'super_admin' ||
              settings.adminPermissions.dashboard.allowLastViewedProfilesKEY ===
                true ? (
                <ListItem>
                  <FormControlLabel
                    label={t('lastViewedKeyEmployees')}
                    labelPlacement='start'
                    classes={{ label: classes.labelSize }}
                    control={
                      <Switch
                        checked={lastViewedProfiles}
                        onChange={() => changeLastViewedProfileStatus()}
                        size='small'
                        color='orange'
                      />
                    }
                  />
                </ListItem>
              ) : null}

              {/* Tagged employees */}
              <ListItem>
                <FormControlLabel
                  label={t('taggedEmployees')}
                  labelPlacement='start'
                  classes={{ label: classes.labelSize }}
                  control={
                    <Switch
                      checked={taggedProfiles}
                      onChange={() => changeTaggedProfilesStatus()}
                      size='small'
                      color='orange'
                    />
                  }
                />
              </ListItem>

              {/* Last agency applicants */}
              <ListItem>
                <FormControlLabel
                  label={t('lastAgencyApplicants')}
                  labelPlacement='start'
                  classes={{ label: classes.labelSize }}
                  control={
                    <Switch
                      checked={lastAgencyApplicants}
                      onChange={() => changeLastAgencyApplicantsStatus()}
                      size='small'
                      color='orange'
                    />
                  }
                />
              </ListItem>

              {/* Last online applicants */}
              <ListItem>
                <FormControlLabel
                  label={t('lastOnlineApplicants')}
                  labelPlacement='start'
                  classes={{ label: classes.labelSize }}
                  control={
                    <Switch
                      checked={lastOnlineApplicants}
                      onChange={() => changeLastOnlineApplicantsStatus()}
                      size='small'
                      color='orange'
                    />
                  }
                />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  userData: state.agencyUserDataRed.obj
})

export default connect(mapStateToProps)(DashboardSettings)
